import { CustomerStatsData } from '@/api';

export const statsDemoData: CustomerStatsData = {
  byLevel: {
    low: 1,
    medium: 1,
    high: 2,
    severe: 1,
    na: 0,
  },
  totals: {
    byLevel: 5,
  },
};
